const TimeoutDirective = function () {
    return {
        restrict: 'E',
        scope: {
            left: '@left',
            remainingLabelSingular: '@?remainingLabelSingular',
            remainingLabelPlural: '@?remainingLabelPlural',
            expiredScreenReaderLabel: '@?expiredScreenReaderLabel'
        },
        template: '<span>' +
            '<span class="countdown" aria-hidden="true">{{remainder}}</span>' +
            '<span class="sr-only" aria-live="polite" aria-atomic="true" role="status">{{screenReaderAnnouncement}}</span>' +
            '</span>',

        controller: function ($scope, $http) {
            if ($scope.left) {
                var expiryDate = new Date();
                var timeLeft = $scope.left || 0;
                var timer;
                var remainingLabelSingular = ($scope.remainingLabelSingular || 'Remaining reservation time: {count} minute.').trim();
                var remainingLabelPlural = ($scope.remainingLabelPlural || 'Remaining reservation time: {count} minutes.').trim();
                var expiredScreenReaderLabel = ($scope.expiredScreenReaderLabel || 'Your reservation has expired').trim();
                var lastAnnouncedSeconds = null;

                // setting the expiry date
                if (timeLeft !== 0) {
                    var tmp = timeLeft.split(':');
                    var seconds = (+tmp[ 0 ]) * 60 * 60 + (+tmp[ 1 ]) * 60 + (+tmp[ 2 ]);
                    expiryDate.setSeconds(expiryDate.getSeconds() + seconds);
                    expiryDate.setHours(expiryDate.getHours() - 1);
                } else {
                    if (typeof ga !== "undefined") {
                        // Tracking 2a: Basket gets a timeout for reservation time which is equally to remainder - 0
                        ga('set', 'page', 'newCO_emptyBasket_timeout');
                        ga('send', 'pageview');
                    }
                }

                $scope.remainder = getRemainderString(getTimeRemaining(expiryDate));
                $scope.screenReaderAnnouncement = '';

                timer = setInterval(function () {
                    var remainderObject = getTimeRemaining(expiryDate);
                    if (remainderObject.total > 0) {
                        maybeUpdateAnnouncement(remainderObject);
                        $scope.remainder = getRemainderString(remainderObject);
                        $scope.$apply();
                    } else {
                        $scope.screenReaderAnnouncement = expiredScreenReaderLabel;
                        $scope.$apply();
                        clearInterval(timer);
                        if (typeof amazon !== 'undefined' && typeof amazonPay !== 'undefined') {
                            amazonPay.triggerLogout(true);
                        }
                        $http.get('/app.php?view=purchase')
                            .then(function () {
                                location.href = '/app.php?view=purchase';
                            });
                    }
                }, 1000);

                $scope.$on('$destroy', function () {
                    if (timer) {
                        clearInterval(timer);
                    }
                });
            }

            function maybeUpdateAnnouncement(remainderObject) {
                var totalSeconds = Math.floor(remainderObject.total / 1000);

                if (totalSeconds <= 0 || totalSeconds === lastAnnouncedSeconds) {
                    return;
                }

                if (totalSeconds >= 300 && totalSeconds % 300 === 0) {
                    updateAnnouncement(totalSeconds);
                    return;
                }

                if (totalSeconds < 300 && totalSeconds % 60 === 0) {
                    updateAnnouncement(totalSeconds);
                }
            }

            function updateAnnouncement(totalSeconds) {
                var minutesLeft = Math.ceil(totalSeconds / 60);
                var labelTemplate = minutesLeft === 1 ? remainingLabelSingular : remainingLabelPlural;

                $scope.screenReaderAnnouncement = labelTemplate.replace('{count}', minutesLeft);
                lastAnnouncedSeconds = totalSeconds;
            }

            function getRemainderString(remainderObject) {
                var remainder = remainderObject.minutes + ':' + remainderObject.seconds;
                if (remainderObject.hours !== '00') {
                    remainder = remainderObject.hours + ':' + remainder;
                }
                return remainder;
            }

            function getTimeRemaining(endtime) {
                var t = Date.parse(endtime) - new Date();
                var seconds = Math.floor((t / 1000) % 60);
                var minutes = Math.floor((t / 1000 / 60) % 60);
                var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
                var days = Math.floor(t / (1000 * 60 * 60 * 24));
                //var minutes =+ hours*60; // See "5bc9f84" - i am not sure about this double declaration
                return {
                    'total': t,
                    'days': ("0" + days).slice(-2),
                    'hours': ("0" + hours).slice(-2),
                    'minutes': ("0" + minutes).slice(-2),
                    'seconds': ("0" + seconds).slice(-2)
                };
            }
        }
    };
};

export default TimeoutDirective;
